import React from "react";
import DDados from "../habitese.ddados";
import autoBind from "react-autobind";
import BaseComponent, { connect } from "@common/components/base.component";
import HabiteseForm from "../components/habitese.form";
import habiteseActions from '../store/habitese.actions';

class Container extends BaseComponent {
  constructor(props) {
    super(props, DDados);
    autoBind(this);
  }

  onPrintReport() {
    this.props.habiteseActions.getImprimirHabitese();
  }

  render() {
    return <HabiteseForm title="Impressão Habite-se" onPrintReport={this.onPrintReport} onPrint={true} />;
  }
}

export default connect({
  actions: {
    habiteseActions,
  }
})(Container);
